import React, { useCallback } from 'react';
// import PropTypes from 'prop-types';
import { useInput, FieldTitle } from 'ra-core';
import { DatePicker, TimePicker, DateTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';

const Picker = ({ PickerComponent, ...fieldProps }) => {

    const {
        options,
        label,
        source,
        resource,
        className,
        isRequired,
        // providerOptions,
    } = fieldProps;

    const { input, meta } = useInput({ source });

    const { touched, error } = meta;

    const handleChange = useCallback(value => {
        Date.parse(value) ? input.onChange(value.toISOString()) : input.onChange(null);
    }, [input]);

    return (
        <div className="picker">
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <PickerComponent
                    {...options}
                    label={<FieldTitle
                        label={label}
                        source={source}
                        resource={resource}
                        isRequired={isRequired}
                    />}
                    disablePast
                    // format={"dd/MM/yyyy"}
                    margin="normal"
                    error={!!(touched && error)}
                    helperText={touched && error}
                    className={className}
                    value={input.value ? new Date(input.value) : null}
                    onChange={date => handleChange(date)}
                    onBlur={() => input.onBlur(input.value ? new Date(input.value).toISOString() : null)}
                />
            </MuiPickersUtilsProvider>
        </div>
    )
}

export const DateInput = props => <Picker PickerComponent={DatePicker} {...props} />
export const TimeInput = props => <Picker PickerComponent={TimePicker} {...props} />
export const DateTimeInput = props => <Picker PickerComponent={DateTimePicker} {...props} />